/* Shopify-native signup and success dialog. Browser storage contains flags only. */
(() => {
  if (window.AnwraNewsletter) return;
  window.AnwraNewsletter = true;
  const dialog = document.querySelector('#welcome-offer');
  const teaser = document.querySelector('.offer-teaser');
  const code = dialog?.dataset.discountCode || 'ANWRA15';
  const seenKey = 'anwra:welcome-offer:seen:v2';
  const subscribedKey = 'anwra:newsletter:success:v1';
  const teaserKey = 'anwra:welcome-offer:teaser-hidden:v2';
  const flag = key => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const save = key => { try { sessionStorage.setItem(key, '1'); } catch { /* Signup and discount links still work. */ } };
  const forms = [...document.querySelectorAll('form.newsletter-form,form.offer-email-form')];
  forms.forEach(form => form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    form.setAttribute('aria-busy', 'true');
    // Let the browser submit the native form. Never fabricate a success response.
    let feedback = form.querySelector('[data-newsletter-feedback]');
    if (!feedback) {
      feedback = document.createElement('p'); feedback.className = 'newsletter-result';
      feedback.dataset.newsletterFeedback = ''; feedback.setAttribute('role','status');
      form.append(feedback);
    }
    feedback.textContent = 'Submitting securely. Complete verification if prompted.';
    setTimeout(() => {
      if (!form.isConnected || form.getAttribute('aria-busy') !== 'true') return;
      form.removeAttribute('aria-busy');
      feedback.textContent = 'Your signup has not been confirmed. Please complete verification if shown, then try again.';
    }, 20000);
  }));
  let pendingStep = null;
  let previousFocus;
  const setStep = step => {
    dialog.querySelectorAll('[data-offer-step]').forEach(stage => {
      stage.hidden = stage.dataset.offerStep !== step;
      stage.querySelector('h2')?.removeAttribute('id');
    });
    const title = dialog.querySelector(`[data-offer-step="${step}"] h2`);
    title.id = 'offer-title'; title.tabIndex = -1;
    dialog.scrollTop = 0;
  };
  const show = (step = 'intro') => {
    if (!dialog || !teaser) return;
    const pet = dialog.querySelector('.offer-pet');
    if (pet) pet.loading = 'eager';
    if (dialog.open) {
      setStep(step); dialog.querySelector('#offer-title').focus({preventScroll:true}); return;
    }
    if (document.querySelector('dialog[open]')) { pendingStep = step; return; }
    pendingStep = null; previousFocus = document.activeElement;
    setStep(step); teaser.hidden = true; dialog.showModal();
    dialog.querySelector('#offer-title').focus({preventScroll: true}); save(seenKey);
  };
  const positionTeaser = () => {
    if (!teaser) return;
    const purchase = document.querySelector('.floating-purchase');
    const r = purchase?.getBoundingClientRect();
    const visible = purchase && !purchase.hidden && getComputedStyle(purchase).display !== 'none' && r.top < innerHeight && r.bottom > 0;
    teaser.style.setProperty('--offer-bottom', `${visible ? Math.max(20, innerHeight - r.top + 12) : 20}px`);
  };
  if (dialog && teaser) {
    dialog.querySelector('.offer-yes').addEventListener('click', () => {
      setStep('email'); dialog.querySelector('input[type="email"]').focus({preventScroll:true});
    });
    dialog.querySelectorAll('.offer-close,.offer-later,.offer-done').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => { teaser.hidden = flag(teaserKey) || flag(subscribedKey); positionTeaser(); previousFocus?.focus(); });
    teaser.querySelector('.offer-reopen').addEventListener('click', () => show(flag(subscribedKey) ? 'done' : 'intro'));
    teaser.querySelector('.offer-teaser-close').addEventListener('click', () => {save(teaserKey); teaser.hidden = true;});
    document.querySelectorAll('dialog').forEach(other => {
      if (other !== dialog) other.addEventListener('close', () => {if (pendingStep) show(pendingStep);});
    });
    let positionFrame=0;
    const scheduleTeaserPosition=()=>{if(!positionFrame)positionFrame=requestAnimationFrame(()=>{positionFrame=0;positionTeaser();});};
    const purchase = document.querySelector('.floating-purchase');
    if (purchase) {
      new ResizeObserver(scheduleTeaserPosition).observe(purchase);
      new MutationObserver(scheduleTeaserPosition).observe(purchase,{attributes:true,attributeFilter:['hidden','class','style']});
    }
    new MutationObserver(scheduleTeaserPosition).observe(document.body,{attributes:true,attributeFilter:['class']});
    window.addEventListener('resize', scheduleTeaserPosition, {passive:true});
    window.addEventListener('scroll', scheduleTeaserPosition, {passive:true});
    window.visualViewport?.addEventListener('resize',scheduleTeaserPosition,{passive:true});
    window.visualViewport?.addEventListener('scroll',scheduleTeaserPosition,{passive:true});
  }
  const nativeSuccess = document.querySelector('[data-newsletter-success]');
  const nativeError = dialog?.querySelector('[data-newsletter-error]');
  const url = new URL(location.href);
  const returned = url.searchParams.get('anwra_offer') === 'applied';
  const showSuccess = async () => {
    save(subscribedKey); save(seenKey);
    document.querySelectorAll('.newsletter-result').forEach(result => {result.hidden = false;});
    const status = dialog?.querySelector('[data-offer-status]');
    if (status) status.textContent = `Thanks for signing up! Your code is ${code}. Applying your 15% portrait offer…`;
    // Show the server-confirmed success before applying the discount. A second
    // full-page redirect can lose the success state or browser storage access.
    show('done');
    const root = window.Shopify?.routes?.root || '/';
    const redirect = new URL(location.pathname, location.origin);
    const preview = url.searchParams.get('preview_theme_id');
    if (preview) redirect.searchParams.set('preview_theme_id', preview);
    const applyUrl = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect.pathname + redirect.search);
    const applyLink = dialog?.querySelector('.offer-apply-link');
    if (applyLink) applyLink.href = applyUrl;
    try {
      const response = await fetch(applyUrl, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Discount request failed');
      if (status) status.textContent = `Your code ${code} is ready and saved for your next eligible checkout. Enjoy 15% off eligible pet portraits.`;
      const footer = document.querySelector('.footer-newsletter');
      if (footer && !footer.querySelector('[data-newsletter-success]')) {
        const result = document.createElement('p'); result.className = 'newsletter-result'; result.id = 'newsletter-success'; result.setAttribute('role','status');
        result.textContent = `Thanks for signing up! Your portrait offer code: ${code}.`;
        footer.append(result);
      }
    } catch {
      if (status) status.textContent = `Thanks for signing up! Your code is ${code}. Select Apply offer below to save your 15% portrait offer.`;
    }
  };
  const afterLoad = async () => {
    if (window.Shopify?.designMode) return;
    // Only Shopify's server-confirmed form success (or the previous verified
    // return flow) can unlock this stage. A submit click alone never does.
    if (nativeSuccess || (returned && flag(subscribedKey))) {
      await showSuccess();
      return;
    }
    if (!dialog || !teaser) return;
    if (nativeError) {show('email');return;}
    // The welcome offer opens on request. Hidden artwork stays lazy until
    // show(); server-confirmed signup/error states above retain their feedback.
    teaser.hidden = flag(teaserKey) || flag(subscribedKey);positionTeaser();
  };
  // The click-only entry is usable while unrelated resources are still loading.
  // Native signup result dialogs retain the document-load gate below.
  if (teaser && !window.Shopify?.designMode && !nativeSuccess && !nativeError && !(returned && flag(subscribedKey))) {
    teaser.hidden = flag(teaserKey) || flag(subscribedKey);positionTeaser();
  }
  // Native signup feedback waits for this document's load event.
  // Off-screen lazy images intentionally do not block window.load.
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load',afterLoad,{once:true});
})();
